import { DirectorySearchBox } from '@xing-com/crate-master-directory-search-box';

import * as S from './search-header.styled';

export const SearchHeader: React.FC = () => {
  return (
    <S.Container>
      <DirectorySearchBox />
    </S.Container>
  );
};
